import TopBar from '../home/components/TopBar';
import Header from '../home/components/Header';
import ServicesSection from '../home/components/ServicesSection';
import Footer from '../home/components/Footer';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';
import ChatPopup from '../home/components/ChatPopup';

const Servicos = () => {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      
      <div className="py-16">
        <ServicesSection />
      </div>

      <Footer />
      <FloatingWhatsApp />
      <ChatPopup />
    </div>
  );
};

export default Servicos;
